import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../service/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
    constructor(
        private authService: AuthService,
        private router: Router,
    ) { }

    private _check(redirectURL: string): Observable<boolean | UrlTree> {
        return this.authService.check().pipe(
            map((authenticated) => {
                if (authenticated) {
                    return true;
                }
                return this.router.createUrlTree(['auth/login'], { queryParams: { redirectURL } });
            })
        );
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        let redirectUrl = state.url;
        if (redirectUrl === '/login') {
            redirectUrl = '/';
        }
        return this._check(redirectUrl);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        let redirectUrl = state.url;
        if (redirectUrl === '/login') {
            redirectUrl = '/';
        }
        return this._check(redirectUrl);
    }

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
        return this._check('/');
    }
}
